'use strict';

import { view } from '@/functions';

const prefix = '/prohibited-products';

export default [
    {
        path: prefix,
        name: 'prohibited-products',
        meta: {
            title: 'Prohibited products',
            scopes: ['read_prohibited_products', 'write_prohibited_products']
        },
        component: () => view('prohibited-products/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'prohibited-products-info',
        meta: {
            title: 'Prohibited product',
            scopes: ['read_prohibited_products', 'write_prohibited_products']
        },
        component: () => view('prohibited-products/info'),
    },
];
